<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-3" style="top: 6px; align-self: start">
          {{ $t('pbx.sip-account.form.field.name') }}
        </div>
        <div class="col-9" style="align-self: start">
          <z-form-input
            :rules="{ required: true, latin_num: true, max: 255 }"
            :errors_absolute="false"
          >
            <i-input v-model="form.name" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-3">
          {{ $t('pbx.sip-account.form.field.password') }}
        </div>
        <div class="col-9">
          <z-form-input :rules="{ required: true, min: 6, max: 128, password: true }">
            <i-input v-model="form.password" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-3">
          {{ $t('pbx.sip-account.form.field.in_phone') }}
        </div>
        <div class="col-9">
          <z-form-input vid="internal_number_id">
            <i-select
              v-model="form.internal_number_id"
              :filterable="true"
              :clearable="true"
              @on-clear="form.internal_number_id = null"
            >
              <i-option v-for="num in numbers" :key="num.id" :value="num.id" :label="num.number" />
            </i-select>
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-3">
          {{ $t('pbx.sip-account.form.field.out_phone') }}
        </div>
        <div class="col-9">
          <z-form-input vid="caller_id">
            <i-select
              v-model="form.caller_id"
              :filterable="true"
              :clearable="true"
              @on-clear="form.caller_id = null"
            >
              <i-option
                v-for="num in external_numbers"
                :key="num.id"
                :value="num.id"
                :label="num.number"
              />
            </i-select>
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { SipAccountService } from '@pbx/services/SipAccountService';
  import { NumberService } from '@pbx/services/NumberService';
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';

  export default {
    components: {
      BaseModal
    },
    mixins: [PageServerValidationResponseMixin],
    props: {
      id: {
        type: [Number, String],
        default: null
      },

      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      numbers: [],
      external_numbers: [],
      is_button_loading: false,
      prevInternal: '',
      prevExternal: ''
    }),

    mounted() {
      const { name, password, caller_id, internal_number_id } = this.item;

      this.prevInternal = internal_number_id;
      this.prevExternal = caller_id;

      this.form = {
        name,
        password,
        internal_number_id,
        caller_id
      };

      this.get_numbers();
    },

    methods: {
      get_numbers: function () {
        const is_internal = (number_item) => number_item.type === 'internal' && !number_item.used;
        const is_external = (number_item) => number_item.type === 'external';
        const is_used_sip_internal = (number_item) =>
          number_item.id === this.form.internal_number_id;

        NumberService.getSelect().then((res) => {
          const selectedInternal = res.filter((number) => is_used_sip_internal(number));

          this.numbers = res.filter((number) => is_internal(number));
          this.numbers = [...this.numbers, ...selectedInternal];

          this.external_numbers = res.filter((number) => is_external(number));
        });
      },

      clearNumber: function (field) {
        this.form[field] = null;
      },
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;

            const updatedForm = { ...this.form };

            //так как у select @clear не сделает null, предполагаем, что было значение и его стерли
            if (!!this.prevInternal && this.form.internal_number_id === undefined) {
              updatedForm.internal_number_id = null;
            } else if (this.form.internal_number_id !== this.prevInternal) {
              updatedForm.internal_number_id = this.form.internal_number_id;
            } else if (this.form.internal_number_id === this.prevInternal) {
              updatedForm.internal_number_id = undefined;
            }

            if (!!this.prevExternal && this.form.caller_id === undefined) {
              updatedForm.caller_id = null;
            } else if (this.form.caller_id !== this.prevExternal) {
              updatedForm.caller_id = this.form.caller_id;
            } else if (this.form.caller_id === this.prevExternal) {
              updatedForm.caller_id = undefined;
            }

            SipAccountService.editItem(this.id, updatedForm)
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.$noty.server_error(e);
                this.check_server_validation(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>
